export { default as SafetechEncryption } from './safetech-encryption';
